<template>
  <div class="">
    <div class="ui form" id="packages-step">
      <div
        class="ui blue button"
        style="background-color: #092442"
        @click="addVisit()"
      >
        Add Visit
      </div>
    </div>
    <div class="ui divider"></div>
    <div class="ui grid">
      <div class="row">
        <newVisit
          class="ui segment"
          style="width: 100%"
          v-for="(visit, index) in visits"
          :index="index"
          :visit="visit"
          :quantitiesReminders="remainderQuantities"
          :id="visit.id"
          @package-visit="setVisit"
          @visit-remove="removeVisit(visit.id)"
          :key="visit.id"
          :showError="showError"
          v-if="!computingReminders"
        />
      </div>
      <div class="row">
        <div class="fourteen wide column">
          <div
            class="ui blue left labeled icon button"
            style="background-color: #092442"
            @click="previous()"
          >
            <i class="left arrow icon"></i>
            previous
          </div>
        </div>
        <div class="two wide column">
          <button
            class="ui blue right floated right labeled icon button"
            style="background-color: #092442"
            @click="next()"
            :disabled="!validForm"
          >
            <i class="right arrow icon"></i>
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewVisit from '@/components/steps/reservations/new_reservations_steps/packages-visits-components/NewVisit';
export default {
  components: {
    newVisit: NewVisit
  },
  props: {
    reservationVisits: { type: Array, required: true },
    reservationPackages: { type: Array, required: true }
  },
  data() {
    return {
      visits: [],
      canGoNext: [],
      showError: false,
      packagesMap: {},
      remainderQuantities: {},
      validForm: false,
      computingReminders: false
    };
  },
  beforeMount() {
    // adjust total quantities
    if (this.reservationPackages)
      this.reservationPackages.forEach(pack => {
        this.packagesMap[pack.id] = {
          id: pack.id,
          name: pack.name,
          quantity: pack.quantity * pack.units,
          units: pack.units,
          unit_price: pack.unit_price,
          unit_measurement_id: pack.unit_measurement_id
        };
      });

    this.visits = window._.cloneDeep(this.reservationVisits)

    this.visits = this.visits.map(v => ({
      ...v,
      packages: this.getVisitPackages(v)
    }));

    if (this.visits.length === 0) this.addVisit(0);
    this.computeRemainders();
  },
  methods: {
    computeRemainders() {
      // compute the remainder part of packages
      this.computingReminders = true;
      const remainderPackages = { ...this.packagesMap };
      for (const visit of this.visits) {
        for (const visitPackage of visit.packages) {
          remainderPackages[visitPackage.id] = {
            ...remainderPackages[visitPackage.id],
            quantity:
              remainderPackages[visitPackage.id].quantity - visitPackage.quantity
          };
        }
      }
      this.remainderQuantities = remainderPackages;
      this.computingReminders = false;
    },
    getPackageQuantity(visit, packageId) {
      if (Array.isArray(visit.packages)) {
        const p = visit.packages.find(
          visitPackage => visitPackage.id === packageId
        );
        if (p) return p.quantity;
      }
      return null;
    },
    getVisitPackages(visit) {
      const visitPackages = [];
      this.reservationPackages.forEach(selectedPackage => {
        visitPackages.push({
          id: selectedPackage.id,
          name: selectedPackage.name,
          quantity: this.getPackageQuantity(visit, selectedPackage.id),
          units: selectedPackage.units,
          unit_price: selectedPackage.unit_price,
          unit_measurement_id: selectedPackage.unit_measurement_id
        });
      });
      return visitPackages;
    },
    removeVisit(id) {
      let deletedVisitIndex = this.visits.findIndex(visit => visit.id === id);
      this.visits = this.visits.filter(visit => visit.id !== id);
      if (deletedVisitIndex > -1) {
        this.canGoNext.splice(deletedVisitIndex, 1);
        this.validForm = this.isFormValid();
      }
    },
    addVisit() {
      this.visits.push(this.visitObject({}));
      this.canGoNext.push(false);
      this.validForm = false;
    },
    isFormValid() {
      if (this.visits.length === 0) return false;
      const keys = Object.keys(this.remainderQuantities);
      for (const key of keys) {
        if (this.remainderQuantities[key].quantity < 0) return false;
      }
      return this.canGoNext.filter(f => f === false).length === 0;
    },
    setVisit(event) {
      this.visits.forEach((visit, index) => {
        if (visit.id === event.data.visit.id) {
          this.visits[index] = { ...event.data.visit };
        }
      });

      this.computeRemainders();
      this.canGoNext[event.data.index] = event.data.validData;
      this.validForm = this.isFormValid();
    },
    visitObject() {
      let lastVisit = window._.last(this.visits)
      let newId = lastVisit ? lastVisit.id + 1 : 1
      const visit = {
        time: new Date().toISOString(),
        id: newId,
        isNew: true,
        packages: []
      };
      visit.packages = this.getVisitPackages(visit);
      return visit;
    },
    next() {
      this.showError = true;
      this.$emit('reservation-visitsInfo', {
        data: {
          visits: this.visits,
          next: this.validForm
        }
      });
    },
    previous() {
      this.$emit('reservation-goBack');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/steps/reservations/new_reservations_steps/packages-visits-components/PackageVisits.vue